import { FC, useMemo } from 'react';
import { useAppSelector } from 'hooks';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { DropDownComponent } from 'componets/common';

import { setCurrentLanguage, language } from 'utils';

import './index.scss';

export const LanguageSwitcher: FC = () => {
	const languages = useAppSelector((state) => state.settings.globals.languages);

	const { t } = useTranslation();

	const languagesOptions = useMemo(
		() =>
			languages
				? Object.keys(languages).map((item) => {
						return {
							name: t(languages[item]),
							value: item,
						};
				  })
				: [],
		[languages, t],
	);

	return (
		<div className="languageSwitcher">
			<DropDownComponent
				dropdownRender={() => (
					<div className="languageSwitcher__container">
						{languagesOptions.map((item) => {
							return (
								<button
									key={item.value}
									className={classNames('languageSwitcher__item', {
										languageSwitcher__item_active: language === item.value,
									})}
									onClick={() => {
										setCurrentLanguage(item.value).then();

										const langPath = window.location.pathname.split('/')[1];

										if (langPath !== item.value) {
											window.location.href = window.location.pathname.replace(langPath, item.value);
										}
									}}
								>
									{item.name}
								</button>
							);
						})}
					</div>
				)}
				label={language.toUpperCase()}
			/>
		</div>
	);
};
